import { styled } from '@ad-lucy/styled';

export const StyledSvg = styled.svg`
  filter: drop-shadow(-1px 0 3px rgba(0, 0, 0, 0.35));
  margin: 0 auto;

  @media (min-width: 450px) {
    height: 65%;
    width: auto;
  }
`;
